import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideZoneChangeDetection,
  inject,
  provideAppInitializer,
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withViewTransitions,
} from '@angular/router';

import { DatePipe } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import {
  RECAPTCHA_SETTINGS,
  RecaptchaSettings,
} from 'ng-recaptcha-2';
import { ErrorIntercept } from './interceptors/error.interceptor';
import { StringToDateInterceptor } from './interceptors/string-to-date.interceptor';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { CommonService } from './services/common.service';
import { DynamicScriptLoaderService } from './services/dynamicScriptLoaderService.service';
import { CustomDateParserFormatter } from './shared/datepicker-formatter';
import { routes } from './app-routing.module';
import * as Sentry from '@sentry/angular';
import { BackButtonDisableModule } from './services/browserButtonNavigation.api';
import { environment } from '../environments/environment';

export const GLOBAL_IMPORTS = importProvidersFrom(
  BackButtonDisableModule.forRoot()
);

const GetApplicationCulture = (service: CommonService) => {
  return () => {
    service.culture;
  };
};
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withViewTransitions({
        skipInitialTransition: true, // Angular has issue with transition for the initial transition when using view transitions specificacally when app is embed in iframe.
      })
    ),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),

    DatePipe,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
        logErrors: true,
      }),
    },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorIntercept, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: StringToDateInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: environment.siteKey } as RecaptchaSettings,
    },
    provideAppInitializer(() => {
      const initializerFn = GetApplicationCulture(inject(CommonService));
      return initializerFn();
    }),
    DynamicScriptLoaderService,
    CookieService,
    GLOBAL_IMPORTS,
  ],
};
